"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
var Developers = void 0;

Developers = function () {
  function Developers() {
    var $create_app = void 0;
    var $create_app_btn = void 0;
    var $create_app_form = void 0;
    var $currently_creating = void 0;
    var $description_input = void 0;
    var $name_input = void 0;
    $create_app = $(".create-app");
    $create_app_form = $(".create-app div.hidden");
    $create_app_btn = $(".create-another-app");
    $currently_creating = false;
    if ($create_app.hasClass("validation-error") === true) {
      $name_input = $("#id_name");
      $description_input = $("#id_description");
      $create_app_btn.addClass("hidden");
      $create_app_form.removeClass("hidden");
      if ($name_input.parent().hasClass("error") === true) {
        $name_input.prop("placeholder", "Please include a name for your app.");
        $name_input.next().prop("class", "ui_important icon-label");
      }
      if ($description_input.parent().hasClass("error") === true) {
        $description_input.prop("placeholder", "Please include a little info about your app before generating keys.");
        $description_input.next().prop("class", "ui_important icon-label");
      }
      $("html, body").animate({
        scrollTop: $create_app.offset().top
      });
      500;
    }
    $("#api-updates").submit(function (e) {
      e.preventDefault();
      return $.getJSON(this.action + "?callback=?", $(this).serialize(), function (_ref) {
        var Status = _ref.Status;

        var invalidSubmit = void 0;
        var justSubmitted = void 0;
        if (Status === 400) {
          invalidSubmit = $("#api-updates input").val();
          $("#api-updates").addClass("shake");
          return $("#api-updates label").text("Sorry, something went wrong with the email address " + invalidSubmit + ".");
        } else {
          e.preventDefault();
          justSubmitted = $("#api-updates input").val();
          $("#api-updates input").val("");
          $("#api-updates label").addClass("ui_heart");
          return $("#api-updates label").text("Thanks for signing up for API access");
        }
      });
    });
    $create_app_btn.on("click", function (e) {
      e.preventDefault();

      $(this).addClass("hidden");
      return $create_app_form.removeClass("hidden");
    });
    $create_app.on("submit", function (e) {
      if ($currently_creating) {
        e.preventDefault();
      }
      return $currently_creating = true;
    });
  }

  return Developers;
}();

exports.default = Developers;